<template>
    <div class="app has-header">
        <div class="header main">

            <div class="align-left">

            </div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons" />
            </div>
            <div class="align-right">
            </div>
        </div>
        <div class="tablecontainer scrollbar-container" v-if="!loading">
            <div class="base-grid">
                <div class="spots">
                    <h3 class="md-header">{{ $tc('store.structure.businessunit', 2) }}</h3>
                    <div class="two-by-x-grid container scroll-y-a">
                        <div v-for="spot in spotArray">
                            <div v-text="spot.name" class="spot"
                                 :style="getStyle(spot)"
                                 @click="toggleSpot(spot)" v-bind:class="{'selected': selectedSpot === spot}">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="assignments">
                    <h3 class="md-header">{{ $tc('global.general.entry', 2) }}</h3>
                    <div class="container">
                        <div v-if="selectedSpot !== null" class="md-card">
                            <div class="md-card-header" :style="'background: ' + unitColorMap[selectedSpot.unitId]">
                                {{ selectedSpot.name }}
                            </div>
                        </div>
                        <div v-if="selectedSpot !== null" class="md-card-body">
                            <div class="entry-grid" style="height: 1.5em">
                                <div class="employee"></div>
                                <div class="primary entry-label">{{ $tc('pages.positionOverview.mainTasks', 2) }}
                                </div>
                                <div class="secondary entry-label">
                                    {{ $tc('pages.positionOverview.secondaryTasks', 2)
                                    }}
                                </div>
                                <div class="entry-closer"></div>
                            </div>
                            <div v-for="(positioningEntry, index) in selectedPositioningEntry">
                                <div v-for="entry in positioningEntry" class="entry-grid"
                                     :style="getStripedStyle(index)">
                                    <div class="employee picture"
                                         :style="'background: ' + unitColorMap[selectedSpot.unitId]">
                                        <i class="fas fa-user" /></div>
                                    <div class="primary">
                                        <div class="tag-bar" @drop="onDrop($event, entry, true)"
                                             @dragover.prevent @dragenter.prevent>
                                            <div v-for="position in findPositions(entry.id, true)"
                                                 class="tag primary-color"
                                                 draggable
                                                 @dragstart="startDragTag($event, position, positioningTaskMap[position.taskId], entry)">
                                                {{ positioningTaskMap[position.taskId].name }}
                                                <i class="fas fa-times right tag-close"
                                                   @click="deletePositioningTaskAssignment(position)" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="secondary">
                                        <div class="tag-bar" @drop="onDrop($event, entry, false)"
                                             @dragover.prevent @dragenter.prevent>
                                            <div v-for="position in findPositions(entry.id, false)"
                                                 class="tag secondary-color"
                                                 draggable
                                                 @dragstart="startDragTag($event, position, positioningTaskMap[position.taskId], entry)">
                                                {{ positioningTaskMap[position.taskId].name }}
                                                <i class="fas fa-times right tag-close"
                                                   @click="deletePositioningTaskAssignment(position)" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="entry-closer">
                                        <i class="fas fa-trash" v-if="entry.priority === 1"
                                           @click="openDeletePositioningEntryPopup(positioningEntry[0])" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tasks">
                    <h3 class="md-header"> {{ $tc('pages.positionOverview.task', 2) }}
                        <i class="fas fa-magnifying-glass right" style="padding-left: 5px"
                           @click="search = !search"></i>
                        <i class="fas fa-arrow-down-a-z right" v-if="sortDesc" @click="sortDesc = !sortDesc"></i>
                        <i class="fas fa-arrow-down-z-a right" v-if="!sortDesc" @click="sortDesc = !sortDesc"></i>
                        <input class="search" v-if="search" v-model="searchVal" placeholder="Aufgabe eingeben... " />
                    </h3>
                    <div class="container scroll-y-a">
                        <div v-for="task in tasks">
                            <div class="task" draggable
                                 @dragstart="startDragTask($event, task)"> {{ task.name }}
                                <div class="right">
                                    <div class="task-button" @click="openEditPositioningTaskPopup($event, task)">
                                        <i class="fas fa-edit" />
                                    </div>
                                    <div class="task-button" @click="openDeletePositioningTaskPopup($event, task)">
                                        <i class="fas fa-trash" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="new-task" @click="openCreatePositioningTaskPopup($event)"><i
                            class="fas fa-plus" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
    </div>

</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import { mapGetters } from 'vuex';
import { next } from 'lodash/seq';

export default {
    name: 'positioningoverview',
    components: {
        datatable,
    },
    data() {
        return {
            error: false,
            loading: true,
            loadingText: null,
            selectedSpot: null,
            sortDesc: true,
            search: false,
            searchVal: null,
        };
    },

    created: function() {
        if (this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'spotMap', 'positioningTaskMap', 'positioningTaskAssignmentMap', 'positioningEntryMap', 'businessUnitMap', 'storeSettings', 'isSuperUser']),
        headerButtons() {

            let view = this;

            let state = {
                buttons: [],
            };
            //BUTTON 1
            state.buttons.push({
                type: 'block',
                icon: 'fa-sync-alt',
                click: () => {
                    view.refresh(true);
                },
                tooltip: this.$t('global.general.refreshData'),
            });
            state.buttons.push({
                type: 'block green',
                icon: 'fa-plus',
                click: ($event) => {
                    view.addSmallestMissingPositionEntry($event);
                },
                tooltip: this.$t('global.ui.add'),
                helperText: this.$t('pages.positionOverview.addHelp'),
                externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/3045064705',
            });

            state.helperLinks = [
                {
                    title: this.$t('store.structure.getSupport'),
                    helperText: this.$t('store.structure.getSupportHelp'),
                    externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13',
                    externalLabel: this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                },
            ];
            return state;
        },

        selectedPositioningEntry() {
            if (this.selectedSpot === null) return null;

            let map = [];
            Object.values(this.positioningEntryMap).filter(entry => entry.spotId === this.selectedSpot.id)
                .forEach(obj => {
                    const key = obj.employeeCount;
                    if (!map[key]) {
                        map[key] = [];
                    }
                    map[key].push(obj);
                });


            let cleanMap = map.filter(function(item) {
                return item !== null;
            });

            cleanMap.forEach(item => item.sort((a, b) => {
                return a.priority - b.priority;
            }));

            return cleanMap;
        },
        spotArray() {
            if (!this.spotMap) return [];

            return Object.values(this.spotMap).sort((a, b) => {
                let val;
                val = this.businessUnitMap[a.unitId].priority - this.businessUnitMap[b.unitId].priority;
                if (val !== 0) {
                    return val;
                }
                val = Number(b.priority) - Number(a.priority);
                if (val !== 0) {
                    return val;
                }
                return val !== 0 ? val : a.name.toUpperCase().localeCompare(b.name.toUpperCase());
            });
        },
        unitColorMap() {
            let unitColorMap = [];
            Object.values(this.spotMap).filter(spot => spot.isMain).forEach(spot => {
                unitColorMap[spot.unitId] = spot.color;
            });
            return unitColorMap;
        },
        tasks() {
            let tasks = this.positioningTaskMap;

            if (this.search && this.searchVal)
                tasks = Object.values(this.positioningTaskMap).filter(task => task.name.includes(this.searchVal));

            if (this.sortDesc) return tasks;

            return Object.values(tasks).reverse();
        },
    },
    watch: {
        storeId: function(val, oldVal) {
            this.refresh(true);
        },
    },
    // methods that implement data logic.
    methods: {
        refresh: function(force = false) {
            let view = this;
            this.loading = true;
            return view.$helpers.GetSpotMap(force)
                .then(map => {
                    return view.$helpers.GetPositioningTaskMap(force);
                })
                .then(map => {
                    return view.$helpers.GetPositioningEntryMap(force);
                })
                .then(map => {
                    return view.$helpers.GetPositioningTaskAssignmentMap(force);
                })
                .then(map => {
                    return view.$helpers.GetBusinessUnitMap(force);
                })
                .then(map => {
                    view.loading = false;
                })
                .catch(function(error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                    view.loading = false;
                    console.log(error);
                });
        },
        openCreatePositioningTaskPopup($event) {
            let view = this;

            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {
                            label: this.$t('pages.employeeData.name'),
                            key: 'name',
                            hidden: false,
                            type: 'text',
                            value: null,
                        },

                    ],

                    selectCallback: function(item) {

                        view.createPositioningTask(item);
                    },
                },
                header: this.$t('pages.positionOverview.newTask'),
                centered: true,
                expanded: true,
            });
        },
        createPositioningTask: function(item) {
            let view = this;
            let url = '/api/sec/positioningtask';
            let params = {
                storeId: this.storeId,
            };

            let payload = {
                storeId: this.storeId,
                name: item.name,

            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
                data: payload,
            }).then(response => {
                view.$store.commit('setPositioningTaskMapEntry', response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.positionOverview.taskAdded'));
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.positionOverview.taskAddedError'));
                console.log(error);
            });

        },

        openDeletePositioningTaskPopup($event, data) {
            let view = this;
            view.$helpers.OpenAlert({
                header: this.$t('pages.positionOverview.deleteTask'),
                description: this.$t('pages.positionOverview.deleteTaskQuery', [data.name]),
                callbackAccept: (alert) => {
                    alert.hidden = true;
                    view.checkAssigmentsBeforeDeletingTasks(data);
                },
            });
        },
        checkAssigmentsBeforeDeletingTasks(task) {
            Object.values(this.positioningTaskAssignmentMap).filter(pt => pt.taskId === task.id).forEach(pt => {
                this.deletePositioningTaskAssignment(pt);
            });

            this.deletePositioningTask(task);
        },
        deletePositioningTask: function(item) {
            let view = this;
            let url = '/api/sec/positioningtask';
            let params = {
                id: item.id,
                storeId: this.storeId,
            };


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
                },
                params: params,
                url: url,
            }).then(response => {
                view.$store.commit('deletePositioningTaskMapEntry', { id: item.id });

                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.positionOverview.taskDeleted'));
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.positionOverview.taskDeletedError'));
                console.log(error);
            });

        },
        openEditPositioningTaskPopup($event, item) {
            let view = this;

            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        { label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id },
                        {
                            label: this.$t('pages.employeeData.name'),
                            key: 'name',
                            hidden: item.externalStoreId != null,
                            type: 'text',
                            value: item.name,
                        },


                    ],

                    selectCallback: function(item) {

                        view.editPositioningTask(item);
                    },

                },
                header: this.$t('pages.positionOverview.editTask'),
                centered: true,
                expanded: true,
            });
        },
        editPositioningTask: function(item) {
            let view = this;
            let url = '/api/sec/positioningtask';
            let params = {

                storeId: this.storeId,
            };

            let payload = {
                id: item.id,
                storeId: this.storeId,
                name: item.name,
                updateFields: ['name'],
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
                data: payload,
            }).then(response => {
                let data = view.positioningTaskMap[item.id];
                data.name = payload.name;


                view.$store.commit('setPositioningTaskMapEntry', data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.positionOverview.taskEdited'));
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.positionOverview.taskEditedError'));
                console.log(error);
            });

        },
        addSmallestMissingPositionEntry() {
            let nextBiggest = true;

            if (!this.selectedPositioningEntry) {
                this.$helpers.error(this.$t('global.notifications.error'), this.$t('pages.positionOverview.pleaseSelectBU'));
                return;
            }

            let count = 0;
            while (nextBiggest && count < 100) {
                if (!this.selectedPositioningEntry[count] ||
                    this.selectedPositioningEntry[count].length > count + 1) {
                    nextBiggest = false;
                }
                count++;
            }

            let requests = [];
            for (let i = 1; i <= count; i++) {
                let req = {
                    employeeCount: count,
                    spotId: this.selectedSpot.id,
                    priority: i,

                };
                requests.push(req);
            }
            this.createPositioningEntry(requests);
        },
        createPositioningEntry: function(requests) {
            let view = this;
            let url = '/api/sec/positioningentry/multi';
            let params = {
                storeId: this.storeId,
            };

            let payload = {
                storeId: this.storeId,
                requests: requests,

            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
                data: payload,
            }).then(response => {
                response.data.data.forEach(entry => {
                    view.$store.commit('setPositioningEntryMapEntry', entry);
                });

                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.positionOverview.entryAdded'));
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.positionOverview.entryAddedError'));
                console.log(error);
            });

        },

        openDeletePositioningEntryPopup(data) {
            let view = this;
            view.$helpers.OpenAlert({
                header: this.$t('pages.positionOverview.deleteEntry'),
                description: this.$t('pages.positionOverview.deleteEntryQuery', [data.employeeCount]),
                callbackAccept: (alert) => {
                    alert.hidden = true;
                    view.deletePositioningEntry(data);
                },
            });
        },
        deletePositioningEntry: function(item) {
            let view = this;
            let url = '/api/sec/positioningentry';
            let params = {
                spotId: item.spotId,
                employeeCount: item.employeeCount,
                storeId: this.storeId,
            };


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
                },
                params: params,
                url: url,
            }).then(response => {
                view.refresh(true);

                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.positionOverview.entryDeleted'));
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.positionOverview.entryDeletedError'));
                console.log(error);
            });

        },

        createPositioningTaskAssignment: function(item) {
            let view = this;
            let url = '/api/sec/positioningtaskassignment';
            let params = {
                storeId: this.storeId,
            };

            let payload = {
                storeId: this.storeId,
                entryId: item.entryId,
                taskId: item.taskId,
                main: item.main,

            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
                data: payload,
            }).then(response => {

                view.$store.commit('setPositioningTaskAssignmentMapEntry', response.data.data);


                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.positionOverview.assignmentAdded'));
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.positionOverview.addAssignmentError'));
                console.log(error);
            });

        },

        deletePositioningTaskAssignment: function(item) {
            let view = this;
            let url = '/api/sec/positioningtaskassignment';
            let params = {
                id: item.id,
                storeId: this.storeId,
            };


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
                },
                params: params,
                url: url,
            }).then(response => {
                view.$store.commit('deletePositioningTaskAssignmentMapEntry', { id: item.id });

                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.positionOverview.assignmentDeleted'));
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.positionOverview.assignmentDeletedError'));
                console.log(error);
            });

        },
        editPositioningTaskAssignment: function(item) {
            let view = this;
            let url = '/api/sec/positioningtaskassignment';
            let params = {
                storeId: this.storeId,
            };

            let payload = {
                storeId: this.storeId,
                id: item.id,
                entryId: item.entryId,
                taskId: item.taskId,
                main: item.main,
                updateFields: ['entryId', 'taskId', 'main'],

            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
                },
                url: url,
                params: params,
                data: payload,
            }).then(response => {
                let data = view.positioningTaskAssignmentMap[item.id];
                data.entryId = payload.entryId;
                data.taskId = payload.taskId;
                data.main = payload.main;

                view.$store.commit('setPositioningTaskAssignmentMapEntry', data);


                view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.positionOverview.assigmentEdited'));
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('pages.positionOverview.assigmentEditedError'));
                console.log(error);
            });

        },

        toggleSpot(spot) {
            if (this.selectedSpot === spot) {
                this.selectedSpot = null;
            } else {
                this.selectedSpot = spot;
            }
        },
        getStripedStyle(index) {
            if (index % 2 === 0) {
                return { 'background': 'var(--contrast-2)' };
            } else {
                return { 'background': 'var(--contrast-0)' };
            }
        },

        startDragTask(event, task) {
            event.dataTransfer.dropEffect = 'move';
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('newTaskId', task.id);
        },
        onDrop(event, targetEntry, main) {
            let taskId = event.dataTransfer.getData('newTaskId');
            if (taskId) {
                if (this.entryHasTask(targetEntry.id, taskId)) {
                    this.$helpers.error(this.$t('global.notifications.error'), this.$t('pages.positionOverview.entryHasTask', [this.tasks[taskId].name]));
                    return;
                }

                this.createPositioningTaskAssignment({
                    storeId: this.storeId, entryId: targetEntry.id, taskId: taskId, main: main,
                });
                return;
            }

            let mainUnchanged = main === event.dataTransfer.getData('sourceMain');
            if (targetEntry.id === event.dataTransfer.getData('sourceEntryId')
                && mainUnchanged)
                return;

            taskId = event.dataTransfer.getData('editTaskId');
            if (this.entryHasTask(targetEntry.id, taskId) && mainUnchanged) {
                this.$helpers.error(this.$t('global.notifications.error'), this.$t('pages.positionOverview.entryHasTask', [this.tasks[taskId].name]));
                return;
            }

            this.editPositioningTaskAssignment({
                id: event.dataTransfer.getData('editPositionId'),
                storeId: this.storeId,
                entryId: targetEntry.id,
                taskId: taskId,
                main: main,
            });
        },
        startDragTag(event, position, task, entry) {
            event.dataTransfer.dropEffect = 'move';
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('sourceMain', entry.main);
            event.dataTransfer.setData('editTaskId', task.id);
            event.dataTransfer.setData('editPositionId', position.id);
            event.dataTransfer.setData('sourceEntryId', entry.id);
        },
        entryHasTask(entryId, taskId) {
            return Object.values(this.positioningTaskAssignmentMap).filter(pt => pt.taskId === taskId && pt.entryId === entryId).length > 0;
        },
        findPositions(entryId, main) {
            return Object.values(this.positioningTaskAssignmentMap).filter(pt => pt.entryId === entryId && pt.main === main);
        },
        getStyle(spot) {
            return 'background: ' + this.unitColorMap[spot.unitId];
        },
    },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tablecontainer {
    background: var(--contrast-0);
    padding: 10px 20px;
    overflow-y: clip;
}

.has-header > .has-header > .scrollbar-container {
    height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
    top: var(--header-height);
}

.header.top {
    margin: 10px 0;
}

.data-table {
    top: 10px;
    position: relative;
}

.header.date {
    display: inline-flex;
    justify-items: center;
    align-items: center;
    position: absolute;
    left: 20px;
}

.header.date .label {
    color: var(--contrast-4);
    font-family: DistrictProLight;
    font-weight: 200;
    margin-top: -3px;
}

.header.date .label.bold {
    font-family: DistrictProBold;
    font-weight: 800;
    margin-right: 5px;
    margin-top: -3px;
}

.header.date .fa-calendar {
    margin: 0 10px;
    font-size: 20px;
    margin-top: -3px;
}

.header.date .fa-angle-left {
    margin: 0 10px;
    font-size: 25px;
    color: var(--contrast-4);
}

.indicator-view {
    padding: 30px;
    padding-bottom: 50px;
}

.md-header {
    text-align: left;
    color: var(--col-label-default);
    font-family: DistrictProBold, serif;
    font-weight: 800;
    font-size: 24px;
}

.base-grid {
    display: grid;
    grid-template-areas: "spots assignments tasks";
    grid-template-columns: 0.9fr 2.3fr 1fr;
    gap: 2px;
    height: 100%;
}

.spots {
    grid-area: spots;
    background: var(--contrast-1);
    padding: 10px;
}

.assignments {
    grid-area: assignments;
    background: var(--contrast-1);
    padding: 10px;
}

.tasks {
    grid-area: tasks;
    background: var(--contrast-1);
    padding: 10px;
}

.two-by-x-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    gap: 5px;
    background: var(--bg);
}

.container {
    background: var(--bg);
    padding: 20px 20px;
    height: calc(100vh - var(--header-height) - 150px);
    overflow: hidden;
}

.scroll-container {
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
    width: calc(100% + 50px);
}

.scroll-y-a {
    overflow-y: auto;
    scrollbar-width: none;
}

.entry-grid {
    display: grid;
    grid-template-areas: "employee primary secondary close";
    grid-template-columns: 0.5fr 6fr 6fr 0.5fr;
    background: var(--contrast-5);
    color: var(--contrast-0);
    align-items: center;
    padding-left: 5px;
}

.employee {
    grid-area: employee;
    color: var(--contrast-0);
    align-self: center;
    justify-self: center;
}

.picture {
    height: 30px;
    width: 30px;
    padding-top: 2px;
    border-radius: 25px;
}

.entry-label {
    margin: 0 20px;
    font-family: DistrictProBold, serif;
    font-weight: 800;
    text-align: center;
    align-content: center;
}

.primary {
    grid-area: primary;
    text-align: left;
}

.secondary {
    grid-area: secondary;
    text-align: left;
}

.entry-closer {
    grid-area: close;
    align-self: center;
    justify-self: center;
    color: var(--danger);
}

.tag-bar {
    background: var(--bg);
    min-height: 2em;
    border-radius: 15px;
    margin: 5px 5px;
}

.tag {
    display: inline-block;
    min-height: 1.5em;
    border-radius: 15px;
    margin: 5px;
    padding: 0 5px;
    max-width: 17em;
    word-wrap: break-word;
}

.tag:active {
    box-shadow: 5px 5px black;
}

.tag-close {
    line-height: 1.5em;
    vertical-align: middle;
    padding-left: 5px;
}

.primary-color {
    background: orange;
}

.primary-color:active {
    background: darkolivegreen;
}

.secondary-color {
    background: var(--main-color);
}

.secondary-color:active {
    background: darkblue;
}

.spot {
    min-height: 100%;
    align-items: center;
    align-content: center;
    color: var(--contrast-0);
    font-family: DistrictProBold, serif;
    font-weight: 800;
    font-size: 20px;
    width: 7em;
    word-wrap: break-word;
}

.spot:hover {
    opacity: 0.7;
}

.selected {
    box-shadow: 0 0 0 5px var(--md) inset;
}

.task {
    background: var(--contrast-5);
    color: var(--contrast-0);
    min-height: 24px;
    height: 100%;
    border-radius: 15px;
    text-align: left;
    padding: 0 10px;
    margin: 3px 0;
    word-wrap: break-word;
    width: 20em;
}

.task:active {
    background: var(--contrast-4);
    box-shadow: 5px 5px black;
}

.new-task {
    background: var(--contrast-4);
    color: var(--contrast-0);
    border-radius: 15px;
    text-align: center;
    padding: 0 10px;
    margin: 3px 0;
    width: 20em;
}

.right {
    display: flex;
    margin-left: auto;
}

.task-button {
    height: 24px;
    width: 24px;
    text-align: center;
}

.task-button:hover {
    color: var(--contrast-4);
    background: var(--contrast-0);
    border-radius: 15px;
}

.md-card {
    border: none;
}

.md-card-header {
    font-family: DistrictProBold, serif;
    font-weight: 800;
    font-size: 20px;
}

.md-card-body {
    padding: 0;
    max-height: calc(100vh - var(--header-height) - 240px);
    scrollbar-width: none;
}

.search {
    width: 100%;
    background: var(--bg);
    border: none;
    box-shadow: none;
    border-radius: 0;
    font-family: DistrictProLight, serif;
    font-weight: 200;
    font-size: 18px;
    padding: 3px 20px;
}
</style>
